import { t } from "i18next";
import { Position } from "../../interfaces";
import React from "react";

const PositionsSizeDetails = ({ positions }: { positions: Position[] }) => {
  // Filtere die Positionen in zwei separate Arrays basierend auf dem White-Status
  const whitePositions = positions.filter((p) => p.White === true);
  const nonWhitePositions = positions.filter((p) => p.White === false);

  return (
    <div className="my-20">
      <React.Fragment>
        <p className="section-heading">{React.createElement(t("positions"))}</p>
      </React.Fragment>
      <ul className="pl-20 ul_with_numbers ul-li-marker-bold">
        {/* Abschnitt für Positionen mit White = true */}
        {nonWhitePositions.map((p, index) => (
          <li key={index}>
            <h4>{p.articleName}</h4>
            <p>
              <strong> {t("itemNumber").toString()}</strong>
              {` : ${p.articleNumber}`}
            </p>
            <p>
              <strong> {t("size").toString()}</strong>
              {` : ${p.widthByMm} x ${p.heightByMm}`}
            </p>
            <p>
              <strong> {t("number").toString()}</strong>
              {` : ${p.quantity}x`}
            </p>
            {window.location.pathname.includes("/dashboard") && (
              <p>
                <strong> {t("productGroup").toString()}</strong>
                {` : ${p.productGroup}`}
              </p>
            )}
          </li>
        ))}

        {/* Abschnitt für Positionen mit White = false, nur anzeigen, wenn es solche Positionen gibt */}
        {whitePositions.length > 0 && (
          <React.Fragment>
            <p>
              <br />
              {t("whiteNoPrintData").toString()}
              <br />
              <br />
            </p>
            {whitePositions.map((p, index) => (
              <li key={index}>
                <h4>{p.articleName}</h4>
                <p>
                  <strong> {t("itemNumber").toString()}</strong>
                  {` : ${p.articleNumber}`}
                </p>
                <p>
                  <strong> {t("size").toString()}</strong>
                  {` : ${p.widthByMm} x ${p.heightByMm}`}
                </p>
                <p>
                  <strong> {t("number").toString()}</strong>
                  {` : ${p.quantity}x`}
                </p>
                {window.location.pathname.includes("/dashboard") && (
                  <p>
                    <strong> {t("productGroup").toString()}</strong>
                    {` : ${p.productGroup}`}
                  </p>
                )}
              </li>
            ))}
          </React.Fragment>
        )}
      </ul>
    </div>
  );
};

export default PositionsSizeDetails;
